import { render } from "./Solicitudes.vue?vue&type=template&id=74a4247b&scoped=true"
import script from "./Solicitudes.vue?vue&type=script&lang=js"
export * from "./Solicitudes.vue?vue&type=script&lang=js"

import "./Solicitudes.vue?vue&type=style&index=0&id=74a4247b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a4247b"]])

export default __exports__